import { LOGIN_CONTEXT } from "@constants/index";
import {
  BulletinIcon,
  DashboardIcon,
  OpenSourceIcon,
  PolicyIcon,
  ProductIcon,
  ProjectsIcon,
  StaticIcon,
  SystemIcon,
} from "../components/Icons";
import paths, { rootPaths } from "./paths";

export const menuItems = [
  {
    id: "dashboard",
    label: "Dashboard",
    icon: DashboardIcon,
    hasChildren: false,
    path: paths.dashboard,
    name: "navbar.dashboard",
    active: true,
  },
  {
    id: "product",
    label: "Product",
    icon: ProductIcon,
    hasChildren: false,
    path: paths.product,
    name: "navbar.product",
    permission: [LOGIN_CONTEXT.SUPERUSER, LOGIN_CONTEXT.PRODUCT_CREATOR, LOGIN_CONTEXT.PRODUCT_MANAGER, LOGIN_CONTEXT.MANAGER],
    active: true,
  },
  {
    id: "project",
    label: "Project",
    icon: ProjectsIcon,
    hasChildren: true,
    isActive: true,
    name: "navbar.project",
    active: true,
    children: [
      {
        name: "Project List",
        isActive: true,
        path: paths.projectList,
        navName: "navbar.project-list",
        active: true,
      },
      {
        name: "Verification Report List",
        isActive: false,
        path: paths.verificationReportList,
        navName: "navbar.verification-report-list",
        active: true,
      },
      {
        name: "Notice Information List",
        isActive: false,
        path: paths.noticeInformationList,
        navName: "navbar.notice-information-list",
        active: true,
      },
      {
        name: "Verification Comparison",
        isActive: false,
        path: paths.verificationComparison,
        navName: "navbar.verification-comparison",
        active: true,
      },
      {
        name: "SBOM Merge",
        isActive: false,
        path: paths.sbomMerge,
        navName: "navbar.sbom-merge",
        active: true,
      },
      {
        name: "Previews List",
        isActive: false,
        path: paths.previewsList,
        navName: "navbar.previews-list",
        active: true,
      },
      {
        name: "Request List",
        isActive: false,
        path: paths.requestList,
        navName: "navbar.request-list",
        active: true,
      },
      {
        name: "NEXUS Import",
        isActive: false,
        path: paths.importedComponentList,
        navName: "navbar.nexus-import",
        active: true,
      },
    ],
  },
  {
    id: "opensources",
    label: "Open Source",
    icon: OpenSourceIcon,
    hasChildren: true,
    name: "navbar.open-source",
    active: true,
    children: [
      {
        name: "Component List",
        isActive: false,
        path: paths.componentList,
        navName: "navbar.component-list",
        active: true,
      },
      {
        name: "License List",
        isActive: false,
        path: paths.licenseList,
        navName: "navbar.license-list",
        active: true,
      },
    ],
  },
  {
    id: "status",
    label: "Status",
    icon: StaticIcon,
    hasChildren: true,
    name: "navbar.status",
    active: true,
    children: [
      {
        name: "Component Usage Status",
        isActive: false,
        path: paths.componentUsageStatus,
        navName: "navbar.component-usage-status",
        active: true,
      },
      {
        name: "License Usage Status",
        isActive: false,
        path: paths.licenseUsageStatus,
        navName: "navbar.license-usage-status",
        active: true,
      },
      {
        name: "Vulnerability Status",
        isActive: false,
        path: paths.vulnerabilityStatus,
        navName: "navbar.vulnerability-status",
        active: true,
      },
      {
        name: "CVE Status",
        isActive: false,
        path: paths.cveStatus,
        navName: "navbar.cve-status",
        active: true,
      },
      {
        name: "CVE Browsing",
        isActive: false,
        path: paths.cveAnalysis,
        navName: "navbar.cve-browsing",
        active: true,
      },
    ],
  },
  {
    id: "policy",
    label: "Policy",
    icon: PolicyIcon,
    hasChildren: true,
    name: "navbar.policy",
    active: true,
    children: [
      {
        name: "License Policy",
        isActive: false,
        path: paths.licensePolicy,
        navName: "navbar.license-policy",
        active: true,
      },
      {
        name: "Vulnerability Policy",
        isActive: false,
        path: paths.vulnerabilityPolicy,
        navName: "navbar.vulnerability-policy",
        active: true,
      },
      {
        name: "Asset Classification",
        isActive: false,
        path: paths.assetClassification,
        navName: "navbar.asset-classification",
        active: true,
      },
    ],
  },
  {
    id: "bulletin",
    label: "Bulletin",
    icon: BulletinIcon,
    hasChildren: true,
    name: "navbar.bulletin",
    active: true,
    children: [
      {
        name: "Announcement",
        isActive: false,
        path: paths.announcement,
        navName: "navbar.announcement",
        active: true,
      },
      {
        name: "Question and Answer",
        isActive: false,
        path: paths.questionAndAnswer,
        navName: "navbar.question-and-answer",
        active: true,
      },
      {
        name: "FAQ",
        isActive: false,
        path: paths.faq,
        navName: "navbar.faq",
        active: true,
      },
      {
        name: "Archive",
        isActive: false,
        path: paths.archive,
        navName: "navbar.archive",
        active: true,
      },
    ],
  },
  {
    id: "system",
    label: "System",
    icon: SystemIcon,
    hasChildren: true,
    name: "navbar.system",
    active: true,
    children: [
      {
        name: "User",
        isActive: false,
        path: paths.user,
        navName: "navbar.user",
        permission: [LOGIN_CONTEXT.SUPERUSER, LOGIN_CONTEXT.MANAGER, LOGIN_CONTEXT.PRODUCT_CREATOR, LOGIN_CONTEXT.PRODUCT_MANAGER, LOGIN_CONTEXT.PROJECT_MANAGER],
        active: true,
      },
      {
        name: "Role",
        isActive: false,
        path: paths.role,
        navName: "navbar.role",
        permission: [LOGIN_CONTEXT.SUPERUSER],
        active: true,
      },
      {
        name: "SBOM",
        isActive: false,
        path: paths.sbom,
        navName: "navbar.sbom",
        permission: [LOGIN_CONTEXT.SUPERUSER, LOGIN_CONTEXT.MANAGER, LOGIN_CONTEXT.SBOM_EDIT],
        active: true,
      },
      {
        name: "Preferences",
        isActive: false,
        path: paths.preferences,
        navName: "navbar.preferences",
        permission: [LOGIN_CONTEXT.SUPERUSER],
        active: true,
      },
      {
        name: "Work History",
        isActive: false,
        path: paths.workHistory,
        navName: "navbar.work-history",
        permission: [LOGIN_CONTEXT.SUPERUSER, LOGIN_CONTEXT.MANAGER],
        active: true,
      },
    ],
  },
];
